// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMediaCaptureButtonEdf_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z" class="svg-bg"/>
  <path d="M3.45825 16.0001V8.82812H7.94625V10.1921H5.07525V11.6331H7.51725V12.9861H5.07525V14.6361H8.05625V16.0001H3.45825ZM9.48462 16.0001V8.82812H11.5086C12.0586 8.82812 12.5536 8.89779 12.9936 9.03712 13.4336 9.17646 13.8113 9.39279 14.1266 9.68613 14.442 9.97212 14.684 10.3388 14.8526 10.7861 15.0213 11.2335 15.1056 11.7651 15.1056 12.3811 15.1056 12.9971 15.0213 13.5325 14.8526 13.9871 14.684 14.4418 14.4456 14.8195 14.1376 15.1201 13.8296 15.4135 13.4593 15.6335 13.0266 15.7801 12.6013 15.9268 12.1246 16.0001 11.5966 16.0001H9.48462ZM11.1016 14.6911H11.4096C11.7176 14.6911 11.9963 14.6508 12.2456 14.5701 12.495 14.4895 12.7076 14.3611 12.8836 14.1851 13.0596 14.0018 13.1953 13.7635 13.2906 13.4701 13.3933 13.1768 13.4446 12.8138 13.4446 12.3811 13.4446 11.9558 13.3933 11.6001 13.2906 11.3141 13.1953 11.0208 13.0596 10.7898 12.8836 10.6211 12.7076 10.4451 12.495 10.3205 12.2456 10.2471 11.9963 10.1738 11.7176 10.1371 11.4096 10.1371H11.1016V14.6911ZM16.467 16.0001V8.82812H20.988V10.1921H18.084V11.8531H20.57V13.2171H18.084V16.0001H16.467Z" class="svg-fg"/>
</svg>
`;
/**
 * IconMediaCaptureButtonEdf is a generated icon component.
 */
let IconMediaCaptureButtonEdf = IconMediaCaptureButtonEdf_1 = class IconMediaCaptureButtonEdf extends IconBaseElement {
    render() {
        return html `${IconMediaCaptureButtonEdf_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMediaCaptureButtonEdf.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMediaCaptureButtonEdf = IconMediaCaptureButtonEdf_1 = __decorate([
    customElement('zui-icon-media-capture-button-edf')
], IconMediaCaptureButtonEdf);
export { IconMediaCaptureButtonEdf };
